<template>
  <div class="item-box">
    <b-row v-if="item.IsGroup === 1" align-h="between">
      <b-col class="item-btn" @click="select">
        <span>
          <span v-if="!isExpand" :class="{ disabled: isAllHoseholds }" class="item-btn" @click="shrink">
            <icon name="plus" class="fold-icon"></icon>
          </span>
          <span v-if="isExpand"  :class="{ disabled: isAllHoseholds }" class="item-btn">
            <icon name="minus" class="fold-icon"></icon>
          </span>
        </span>
        <span :class="{ disabled: isAllHoseholds }">{{ item.desc }}</span>
      </b-col>
      <b-col>
      </b-col>
    </b-row>
    <b-row v-else>
      <b-col style="margin-left: 24px"
        ><b-form-checkbox
          :id="item.code"
           :disabled="isAllHoseholds"
          class="custom-control-inline select-checkbox"
          v-model="isAdd"
          @change="onchange($event)"
        >
          {{ item.desc }}</b-form-checkbox
        >
      </b-col>
    </b-row>
    <div v-if="isExpand && IsColumn">
      <m-demo-search-select-item
        v-for="item in demos"
        :item="item"
        :key="item.AttributeValueName"
        :deep="1"
        :IsColumn="false"
        :allDemos="[]"
      />
    </div>
  </div>
</template>
  
<script>
export default {
  name: "mDemoSearchSelectItem",
  props: {
    item: {
      type: Object,
    },
    deep: {
      type: Number,
      default: 0,
    },
    allDemos: {
      type: Array,
      default: [],
    },
    IsColumn: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isExpand: true,
      isAllAddTemple: false,
    };
  },
  computed: {
    listType() {
      if (this.$store.state.order.ListType) {
        return this.$store.state.order.ListType;
      } else {
        return 10;
      }
    },
    demos() {
      return this.allDemos.filter((t) => {
        return t.ColumnName === this.item.ColumnName && t.IsGroup === 0;
      });
    },
    isAllHoseholds() {
      return this.$store.getters["order/isAllHoseholds"];
    },
    isAdd: {
      get() {
        return this.$store.getters["order/hasDemoByValue"](
          this.item.ColumnName,
          3,
          this.item.AttributeValue
        );
      },
      set(val) {},
    },
    isAllAdd: {
      get() {
        return this.isAllAddTemple;
      },
      set(val) {
        if (val) {
          for (let item of this.demos) {
            item.DemoCategoryType = 3;
            item.AttributeName = this.item.AttributeName;
            item.AttributeDesc = this.item.AttributeDesc;
            this.$store.dispatch("order/addDemoByItem", item);
          }
        } else {
          for (let item of this.demos) {
            this.$store.dispatch("order/deleteDemo", {
              attributeValue: item.AttributeValue,
              type: "value",
              demoCategoryType: 3,
              columnName: item.ColumnName,
            });
          }
        }
        this.isAllAddTemple = val;
      },
    },
    datasource() {
      return this.$store.getters["config/datasource"];
    },
  },
  mounted() {
    this.thisDeep = this.deep + 1;
  },
  methods: {
    select() {
      if(this.isAllHoseholds)return
      if (this.isExpand) {
        this.isExpand = false;
      } else if (!this.isExpand) {
        this.isExpand = true;
      }
    },
    shrink() {
      this.isExpand = false;
    },
    onchange(val) {
      if (val) {
        this.addDemo();
      } else {
        this.$store.dispatch("order/deleteDemo", {
          attributeValue: this.item.AttributeValue,
          type: "value",
          demoCategoryType: 3,
          columnName: this.item.ColumnName,
        });
      }
    },
    addDemo() {
      this.item.DemoCategoryType = 3;
      this.$store.dispatch("order/addDemoByItem", this.item);
      return true;
    },
  },
};
</script>
  
<style scoped lang="scss">
.all-hosehodls {
  margin-top: 16px;
}

.item-box {
  /*margin-left: 16px;*/
  position: relative;
  display: block;
}


.icon-close {
  margin-left: 32px;
  margin-right: 16px;
}

.item {
  margin-bottom: 16px;
}

.btns {
  margin-left: 8px;
  padding-top: 4px;
}

.btns-block {
  display: inline-block;
  width: 80px;
}

.custom-checkbox {
  min-height: 1rem;
}

.fold-icon {
  vertical-align: sub;
}

.custom-control-input:checked ~ .custom-control-label::before {
  border-color: green !important;
  background-color: green !important;
}

.lable-name {
  margin-bottom: 0px;
}

.add-btn {
  margin: 8px;
}

.add-p {
  margin: 4px;
}
</style>
  


// WEBPACK FOOTER //
// src/components/demo/MDemoSearchSelectItem.vue